import { render } from "./blogPosts.vue?vue&type=template&id=10d9f012&scoped=true"
import script from "./blogPosts.vue?vue&type=script&lang=js"
export * from "./blogPosts.vue?vue&type=script&lang=js"

import "./blogPosts.vue?vue&type=style&index=0&id=10d9f012&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d9f012"]])

export default __exports__